import React from "react";

const About = () => {
  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto", lineHeight: "1.8" }}>
      <h2 style={{ fontSize: "2.5rem", marginBottom: "20px", color: "#2d6a4f" }}>
        About Us
      </h2>
      
      <p style={{ fontSize: "1.1rem", marginBottom: "20px" }}>
        At <strong>Fresh Harvest Organic Fruits</strong>, we are passionate about
        delivering the freshest, organic fruits directly from our farms to your
        table. Our journey began with a simple mission: to promote healthy
        living while supporting sustainable farming practices.
      </p>

      <h3 style={{ color: "#40916c", marginTop: "30px" }}>🌱 Our Mission</h3>
      <p style={{ marginBottom: "20px" }}>
        Our mission is to make fresh, chemical-free fruits accessible to
        everyone. We believe in protecting the environment, supporting local
        farmers, and encouraging healthier food choices for families across the
        community.
      </p>

      <h3 style={{ color: "#40916c", marginTop: "30px" }}>🍎 What We Offer</h3>
      <ul style={{ marginLeft: "20px", marginBottom: "20px" }}>
        <li>Wide variety of seasonal organic fruits</li>
        <li>100% pesticide-free and naturally grown produce</li>
        <li>Farm-to-table delivery for maximum freshness</li>
        <li>Affordable prices without compromising quality</li>
      </ul>

      <h3 style={{ color: "#40916c", marginTop: "30px" }}>🤝 Our Promise</h3>
      <p style={{ marginBottom: "20px" }}>
        When you shop with us, you are not only choosing healthier food but also
        contributing to a greener planet and supporting hardworking local
        farmers. Every fruit you enjoy is a step towards sustainability.
      </p>

      <blockquote
        style={{
          borderLeft: "5px solid #2d6a4f",
          paddingLeft: "15px",
          fontStyle: "italic",
          color: "#555",
          marginTop: "30px"
        }}
      >
        "From our farms to your family — fresh, organic, and full of love."
      </blockquote>
    </div>
  );
};

export default About;
